import { AfterViewInit, Component, Input, Output, ElementRef, EventEmitter, OnInit, NgModule, Renderer, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChartRoutingModule } from './chart.routing.module';
import { PlatformService } from '../../services/platform/platform.service';

declare const $: any;
declare const Chart: any;

@Component({
  selector: 'chart',
  template: `
    <div class="chart">
      <canvas #chartComponent id="{{name}}"></canvas>
      <div id="chartLegend{{name}}" class="white-text"></div>
    </div>
    <div class="modal fade modal-bf-fh" id="chartPref{{name}}" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="flex-center">
              <h4 class="modal-title">Preferences</h4>
            </div>
          </div>
          <div class="modal-body">
            <select class="mdb-select colorful-select dropdown-default" [(ngModel)]="chartType" #select>
              <option *ngFor="let c of typeOption" [value]="c.value">{{c.code}}</option>
            </select>
            <input type="text" [(ngModel)]="title">
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .chart {
        padding: 1rem;
    }
    ul.pie-legend {
        text-align: center;
        margin-top: 2rem;
    }
    ul.pie-legend li {
        display:inline-block;
        margin-right: 10px; 
    }
    ul.pie-legend li span {
        padding: 5px 10px;
        color: #fff;
    }
  `]
})

export class ChartComponent implements AfterViewInit {
  @Input() public name: string = '';
  @Input() public caption: string = '';
  @Input() public enabled: Boolean = false;
  @Input() public data: any;
  @Input() public option: any = { };
  @ViewChild('chartComponent') chartComponent: ElementRef;
  @ViewChild('select') select: ElementRef;
  @Input() public chartType = 0;
  public typeOption = [{ code: 'Bar', value: 0 }, { code: 'Line', value: 1 }, { code: 'Radar', value: 2 }, { code: 'Polar', value: 3 }, { code: 'Pie', value: 4 }, { code: 'Doughnut', value: 5 }];
  public chart: any;
  @Input() public loading: boolean;
  @Input() public title: string;

  constructor(
    public platform: PlatformService,
    renderer: Renderer
  ) {
    this.option = {
      title: {
        display: true,
        text: 'Custom Chart Title'
      },
      responsive: true,
      maintainAspectRatio: true,
      tooltipTemplate: '<%if (label){%><%=label%>: <%}%><%= value %>'
    };
  }

  ngAfterViewInit(): void {
    //this.load();
    $(this.select.nativeElement).material_select();
    $(this.select.nativeElement).on('change', function (this: any, $event: any) {
      //this.load(); //console.log($event.target.value);
    }, ($event: any) => {
      this.chartType = $event.target.value;
      this.load();
    });
  }

  clear() {
    if (this.chart != null) {
      this.chart.destroy();
    }
  }

  load() {
    this.clear();
    this.option['responsive'] = true;
    this.option['maintainAspectRatio'] = true;
    this.option['tooltipTemplate'] = '<%if (label){%><%=label%>: <%}%><%= value %>';
    if (this.title) {
      this.option['title'] = {
        display: true,
        text: this.title
      }
    }
    let chart = null;
    if (this.data) {
      const ctx: any = this.chartComponent.nativeElement.getContext('2d');
      if (this.chartType == 0) {
        let option: any = this.option;
        chart = new Chart(ctx, {
          type: 'bar',
          data: this.data,
          options: option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 1) {
        let option: any = this.option;
        chart = new Chart(ctx, {
          type: 'line',
          data: this.data,
          options: option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 2) {
        chart = new Chart(ctx, {
          type: 'radar',
          data: this.data,
          options: this.option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 3) {
        chart = new Chart(ctx, {
          type: 'polarArea',
          data: this.transformData(this.data),
          options: this.option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 4) {
        chart = new Chart(ctx, {
          type: 'pie',
          data: this.transformData(this.data),
          options: this.option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 5) {
        chart = new Chart(ctx, {
          type: 'doughnut',
          data: this.transformData(this.data),
          options: this.option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      } else if (this.chartType == 6) {
        let option: any = this.option;
        chart = new Chart(ctx, {
          type: 'scatter',
          data: this.data,
          options: option
        });
        //document.getElementById("chartLegend" + this.name).innerHTML = chart.generateLegend();
      }
    }
    this.chart  = chart;
  }

  setData(data: any) {
    this.data = data;
  }

  transformData(dataEntry: any): any {
    const data: any = [];
    if (dataEntry != null) {
      for (let i = 0; i <= dataEntry.labels.length - 1; i++) {
        data.push({
          value: dataEntry.datasets[0].data[i],
          //colors: "#F7464A",
          //highlight: "#F7464A",
          label: dataEntry.labels[i]
        });
      }
    }
    return data;
  }
}
